// src/components/changeRole/ChangeMemberRole.jsx
import React, { useState } from "react";
import { apiUpdateUserRoleByUsername } from "../../api/backend/admin";
import { GlassBtn } from "../../components/buttons";
import { PencilIcon } from "../../components/icons";
import GeneralDropdown from "../generalDropDown/generalDropDown";
import { ROLE_OPTIONS } from "../../constants/adminDashBoard";
import "./changeRole.scss";

const ChangeRole = ({ onSuccess }) => {
  const [usernameValue, setUsernameValue] = useState("");
  const [usernameValueError, setUsernameValueError] = useState("");
  const [newRole, setNewRole] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");
  const [newRoleUserNameFieldFocus, setNewRoleUserNameFieldFocus] =
    useState(false);
  const handleRoleUpdate = async () => {
    // reset errors
    setUsernameValueError("");
    // validation
    if (!usernameValue.trim()) {
      setUsernameValueError("Username is required");
      return;
    }
    try {
      const { data } = await apiUpdateUserRoleByUsername(
        usernameValue,
        newRole
      );
      setUpdateStatus(data.message);
      console.log("Updated user:", data.member);
      if (data.purge && newRole === "member" && onSuccess) {
        onSuccess();
      }
    } catch (error) {
      setUpdateStatus("Error updating user role.");
      console.error(error);
    }
  };

  const usernameWatcher = (e) => {
    setUsernameValueError("");
    setUsernameValue(e.target.value);
  };

  return (
    <div id="change-role">
      <div className="username-field blinker-wrapper">
        <input
          type="text"
          placeholder={usernameValueError || "Enter username"}
          className={usernameValueError ? "input-error-message-role" : ""}
          value={usernameValue}
          onChange={usernameWatcher}
          onFocus={() => setNewRoleUserNameFieldFocus(true)}
          onBlur={() => setNewRoleUserNameFieldFocus(false)}
        />
        {!newRoleUserNameFieldFocus && !usernameValue && (
          <span className="blinking-cursor-gold-color username-role-cursor">
            |
          </span>
        )}
      </div>
      {/* Replace <select> with GeneralDropdown */}
      <GeneralDropdown
        options={ROLE_OPTIONS}
        value={newRole}
        onChange={setNewRole}
        placeholder="Select role"
      />
      <div className="update-container">
        <GlassBtn
          glassBtnImage={
            <PencilIcon height="25px" width="25px" fillColor="#fdfd96" />
          }
          glassHoverStyle={{
            height: "60px",
          }}
          onClick={handleRoleUpdate}
          className="updateCtrl"
          glassBtnText="Update Role"
          glassBtnTextFontSize="1.3rem"
          glassBtnFontWeight="900"
          glassBtnFontColor="#fdfd96"
          glassBtnTextDecorationColor="#fdfd96"
        />
      </div>
      {updateStatus && <p className="status">{updateStatus}</p>}
    </div>
  );
};

export default ChangeRole;
